import React from "react";
import "../styles/FounderCard.css";

export default function FounderCard({
  founders = [],
  eyebrow,
  sectionHeading,
}) {
  if (!founders.length) return null;

  return (
    <section className="tp-story-founders">
      <div className="tp-story-founders__container">
        {/* <div className="tp-story-founders__header">
          {eyebrow && (
            <span className="tp-story-founders__eyebrow">{eyebrow}</span>
          )}
          {sectionHeading && (
            <h2 className="tp-story-founders__section-heading">
              {sectionHeading}
            </h2>
          )}
        </div> */}

        <div className="tp-story-founders__list">
          {founders.slice(0, 2).map((founder, index) => (
            <article
              className={`tp-founder ${
                index === 1 ? "tp-founder--reverse" : ""
              }`}
              key={founder.id || founder.name}
            >
              <div className="tp-founder__decoration" />

              <div className="tp-founder__photo">
                {founder.image ? (
                  <img
                    src={founder.image}
                    alt={founder.name}
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                ) : (
                  <div className="tp-founder__photo-fallback">
                    <span>{founder.initials}</span>
                  </div>
                )}
              </div>

              <div className="tp-founder__content">
                {founder.eyebrow && (
                  <span className="tp-founder__eyebrow">{founder.eyebrow}</span>
                )}

                <h3 className="tp-founder__heading">{founder.heading}</h3>

                <p className="tp-founder__quote">{founder.quote}</p>

                <div className="tp-founder__details">
                  <h4 className="tp-founder__name">{founder.name}</h4>

                  <span className="tp-founder__title">{founder.title}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
